module.exports = __webpack_public_path__ + "assets/img/69_525_3.e5e9f7a4.jpg";